import React from "react";
import { FormControl, FormHelperText, TextField } from "@mui/material";
import { Field } from "formik";
import PropTypes from "prop-types";
import FormikLabel from "./FormLabel";

const ColorPickerFieldComponent = ({
  field,
  errors,
  touched,
  handleFieldChange,
}) => (
  <FormControl
    fullWidth
    error={touched[field.fieldId] && !!errors[field.fieldId]}
  >
    <FormikLabel text={field.fieldName} required={field.required} />
    <Field name={field.fieldId}>
      {({ field: formikField }) => (
        <TextField
          {...formikField}
          type="color" // Use color input type
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              borderWidth: "1px",
              cursor: field.disabled ? "not-allowed" : "inherit",
            },
            "& .MuiInputBase-input": {
              padding: "8px",
              backgroundColor:
                field.disabled || field.readOnly ? "#f5f5f5" : "inherit",
              cursor:
                field.disabled || field.readOnly ? "not-allowed" : "inherit",
            },
          }}
          value={formikField.value || "#ffffff"} // Default to white if empty
          onChange={(event) => {
            formikField.onChange(event); // Update Formik state
            handleFieldChange(event, field.fieldId); // Custom handler
          }}
        />
      )}
    </Field>
    <FormHelperText>
      {touched[field.fieldId] && errors[field.fieldId]}
    </FormHelperText>
  </FormControl>
);

ColorPickerFieldComponent.propTypes = {
  field: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
};

export default ColorPickerFieldComponent;
